import { headingSpacingMappings } from "../../app/(site)/_components/SanityGroups/HeadingGroup/helpers/headingSpacingMappings"

/**
 * Helper function to map heading spacing (gap) class names to their correct CSS class equivalents.
 *
 * Example usage:
 *
 *   <div className={clsx("flex flex-col", gapClass("heading-5xl-bold"))}>
 *     ...
 *   </div>
 *   // If "heading-5xl-bold" is mapped, this will output:
 *   // <div class="flex flex-col mb-32 md:mb-64">...</div>
 *
 */

export function gapClass(input: string | null | undefined): string {
    if (!input) return ""

    return input
        .split(/\s+/)
        .map(cls => headingSpacingMappings[cls] ?? cls)
        .join(" ")
}
